var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPurplePin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 27.4 34.1",
    style: {
      enableBackground: "new 0 0 27.4 34.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8,0H13C6.5,0.3,0.4,6.1,0,12.5c-0.3,4.4,1.6,8.7,5.1,11.4c3.3,2.5,6,5.6,7.9,9.2l0.4,0.8c0,0.1,0.2,0.2,0.3,0.1h0.1 c0.1,0,0.1,0,0.1-0.1l0.2-0.4c2-3.7,4.7-6.9,8-9.5c3.3-2.5,5.3-6.4,5.3-10.6C27.4,5.9,21.2-0.1,13.8,0z M13.7,18.6 c-3,0-5.4-2.4-5.4-5.3S10.7,8,13.7,8c3,0,5.4,2.4,5.4,5.3S16.7,18.6,13.7,18.6z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurplePin);
export default __webpack_public_path__ + "static/media/purple_pin.6d3e9960d8b06680acec6cccfa8ca18b.svg";
export { ForwardRef as ReactComponent };